<template>

    <div class="profile-dashboard__info">

        <div class="profile-dashboard__info-content">
            <div class="profile-dashboard__info-title">
                {{$store.getters.t('user_dashboard_hello_prefix')}} {{user.name}}{{$store.getters.t('user_dashboard_hello_suffix')}}
            </div>
            <div class="profile-dashboard__info-description">
                {{$store.getters.t('user_dashboard_thank_you')}}<br>
                {{$store.getters.t('user_dashboard_last_month')}}
                <span>
                    {{
                        ((dashboard && +dashboard.last_month_donated_pets_count) || 0) +
                        ((dashboard && +dashboard.processed_donorships_count) || 0)
                    }} {{$store.getters.t('user_dashboard_animals')}}
                </span>
                {{$store.getters.t('user_dashboard_received_help')}}
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "UserDashboardInfo",
    props: ['user', 'dashboard'],

}
</script>

<style scoped>

</style>
